import classNames from 'classnames'
import { BodyLong, Button } from '@navikt/ds-react'
import PT from 'prop-types'
import React, { useEffect, useState } from 'react'
import ReactResizeDetector from 'react-resize-detector'
import { WidgetDeleteProps } from 'index.d'
import styled, { keyframes } from 'styled-components'
import { LabelsPropType } from 'index.pt'

const fadeIn = keyframes`
  0% {
    opacity: 0;
    top: -9999px;
  }
  1% {
    opacity: 0;
    top: 5px;
  }
  100% {
    opacity: 1;
    top: 5px;
  }
`
const fadeOut = keyframes`
  0% {
    opacity: 1;
    top: 5px;
  }
  99%{
    opacity: 0;
    top: 5px;
  }
  100% {
    opacity: 0;
    top: -9999px;
  }
`
export const WidgetDeleteDiv = styled.div`
  position: absolute;
  left: 50%;
  top: -9999px;
  opacity: 0;
  &.active {
    animation: ${fadeIn} 0.3s forwards; 
    dfis: none;
  }
  &.notactive {
    animation: ${fadeOut} 0.3s forwards; 
  }
`
const WidgetDeletePlaceholder = styled.div`
  left: -50%;
  position: relative;
  background-color: var(--navds-semantic-color-canvas-background);
  color: var(--navds-color-text-primary);
  border: 1px solid var(--navds-semantic-color-border);
  box-shadow: 3px 3px 3px var(--navds-semantic-color-component-background-alternate);
  flex-direction: column;
  flex: 1;
  text-align: center;
  justify-content: center;
  height: 100%;
  display: flex;
  overflow: auto;
`
const DeleteText = styled.div`
  margin-top: 1rem;
  margin-bottom: 1rem;
`
const WidgetDelete: React.FC<WidgetDeleteProps> = ({
  active, labels, onResize, onDelete, setMode
}: WidgetDeleteProps): JSX.Element => {
  const [_active, setActive] = useState<boolean | undefined>(undefined)
  const onWidgetDeleteClick = (e: React.MouseEvent): void => {
    e.stopPropagation()
    e.preventDefault()
    onDelete()
  }

  useEffect(() => {
    if (active === true || (active === false && _active === true)) {
      if (active !== _active) {
        setActive(active)
      }
    }
  }, [_active, active])

  return (

    <WidgetDeleteDiv className={classNames({
      active: _active === true,
      notactive: _active === false
    })}
    >
      <WidgetDeletePlaceholder>
        <ReactResizeDetector
          handleWidth
          handleHeight
          onResize={onResize}
        />
        <DeleteText>
          <BodyLong>
            {labels.deleteWidgetAreYouSure1}
          </BodyLong>
          <BodyLong>
            {labels.deleteWidgetAreYouSure2}
          </BodyLong>
        </DeleteText>
        <div className='buttons'>
          <Button
            variant='primary'
            size='small'
            id='c-d-WidgetDelete__delete-button-id'
            className='c-d-WidgetDelete__delete-button'
            onClick={onWidgetDeleteClick}
          >
            {labels.yes_delete}
          </Button>
          <Button
            variant='secondary'
            size='small'
            id='c-d-WidgetDelete__cancel-button-id'
            className='c-d-WidgetDelete__cancel-button'
            onClick={() => setMode('edit')}
          >
            {labels.no_cancel}
          </Button>
        </div>
      </WidgetDeletePlaceholder>
    </WidgetDeleteDiv>
  )
}

WidgetDelete.propTypes = {
  active: PT.bool.isRequired,
  highContrast: PT.bool.isRequired,
  labels: LabelsPropType.isRequired,
  onResize: PT.func.isRequired,
  onDelete: PT.func.isRequired,
  setMode: PT.func.isRequired
}
export default WidgetDelete
